var _regeneratorRuntime = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var Promise = require('bluebird'),
    _require = require('./util'),
    isIterable = _require.isIterable,
    _require2 = require('./get'),
    chainExists = _require2.chainExists,
    _require3 = require('./ack'),
    waitOnCommitAck = _require3.waitOnCommitAck,
    waitOnRevealAck = _require3.waitOnRevealAck,
    _require4 = require('./addresses'),
    getPublicAddress = _require4.getPublicAddress,
    _require5 = require('./chain'),
    Chain = _require5.Chain,
    composeChainCommit = _require5.composeChainCommit,
    composeChainCommitDelegateSig = _require5.composeChainCommitDelegateSig,
    composeChainReveal = _require5.composeChainReveal,
    _require6 = require('./entry'),
    Entry = _require6.Entry,
    composeEntryCommit = _require6.composeEntryCommit,
    composeEntryCommitDelegateSig = _require6.composeEntryCommitDelegateSig,
    composeEntryReveal = _require6.composeEntryReveal; //////////// Commit /////////////


function commit(factomd, obj, ecAddress, options) {
  switch (obj.constructor) {
    case Entry:
      return commitEntry(factomd, obj, ecAddress, options);

    case Chain:
      return commitChain(factomd, obj, ecAddress, options);

    default:
      throw new Error('Argument of `commit` is not an instance of Chain or Entry');
  }
}

function commitChain(_x, _x2, _x3, _x4) {
  return _commitChain.apply(this, arguments);
}

function _commitChain() {
  _commitChain = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(factomd, chain, ecAddress, options) {
    var commit;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return chainExists(factomd, chain.id);

          case 2:
            if (!_context.sent) {
              _context.next = 4;
              break;
            }

            throw new Error("Chain ".concat(chain.idHex, " already exists."));

          case 4:
            if (!(typeof options === 'object' && typeof options.sign === 'function')) {
              _context.next = 10;
              break;
            }

            _context.next = 7;
            return composeChainCommitDelegateSig(chain, ecAddress, options.sign).then(function (c) {
              return c.toString('hex');
            });

          case 7:
            commit = _context.sent;
            _context.next = 11;
            break;

          case 10:
            commit = composeChainCommit(chain, ecAddress).toString('hex');

          case 11:
            return _context.abrupt("return", sendCommit({
              factomd: factomd,
              commitApiCall: 'commit-chain',
              commit: commit,
              ackTimeout: getAckTimeout(options)
            }));

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _commitChain.apply(this, arguments);
}

function commitEntry(_x5, _x6, _x7, _x8) {
  return _commitEntry.apply(this, arguments);
} // Backward compatibility:
// arg used to be directly the ackTimeout before being changed for an options object


function _commitEntry() {
  _commitEntry = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(factomd, entry, ecAddress, options) {
    var commit;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (entry.chainId.length) {
              _context2.next = 2;
              break;
            }

            throw new Error('Entry should contain a chain id to be committed');

          case 2:
            if (!(typeof options === 'object' && typeof options.sign === 'function')) {
              _context2.next = 8;
              break;
            }

            _context2.next = 5;
            return composeEntryCommitDelegateSig(entry, ecAddress, options.sign).then(function (c) {
              return c.toString('hex');
            });

          case 5:
            commit = _context2.sent;
            _context2.next = 9;
            break;

          case 8:
            commit = composeEntryCommit(entry, ecAddress).toString('hex');

          case 9:
            return _context2.abrupt("return", sendCommit({
              factomd: factomd,
              commitApiCall: 'commit-entry',
              commit: commit,
              ackTimeout: getAckTimeout(options)
            }));

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _commitEntry.apply(this, arguments);
}

function getAckTimeout(arg) {
  if (typeof arg === 'object') {
    return arg.ackTimeout;
  } else if (typeof arg === 'number') {
    return arg;
  }
}

function sendCommit(_x9) {
  return _sendCommit.apply(this, arguments);
} //////////// Reveal /////////////


function _sendCommit() {
  _sendCommit = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(_ref) {
    var factomd, commit, commitApiCall, _ref$ackTimeout, ackTimeout, repeatedCommit, committed;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            factomd = _ref.factomd, commit = _ref.commit, commitApiCall = _ref.commitApiCall, _ref$ackTimeout = _ref.ackTimeout, ackTimeout = _ref$ackTimeout === void 0 ? 60 : _ref$ackTimeout;
            repeatedCommit = false;
            _context3.next = 4;
            return factomd.call(commitApiCall, {
              message: commit
            }).catch(function (e) {
              if (e.code === -32011) {
                repeatedCommit = true;
              } else {
                throw e;
              }
            });

          case 4:
            committed = _context3.sent;

            if (!(committed && ackTimeout >= 0)) {
              _context3.next = 8;
              break;
            }

            _context3.next = 8;
            return waitOnCommitAck(factomd, committed.txid, ackTimeout);

          case 8:
            return _context3.abrupt("return", {
              txId: committed ? committed.txid : undefined,
              repeatedCommit: repeatedCommit
            });

          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _sendCommit.apply(this, arguments);
}

function reveal(factomd, obj, ackTimeout) {
  switch (obj.constructor) {
    case Entry:
      return revealEntry(factomd, obj, ackTimeout);

    case Chain:
      return revealChain(factomd, obj, ackTimeout);

    default:
      throw new Error('Argument of `reveal` is not an instance of Chain or Entry');
  }
}

function revealChain(factomd, chain, ackTimeout) {
  return revealInternal(factomd, chain, composeChainReveal, 'reveal-chain', ackTimeout);
}

function revealEntry(factomd, entry, ackTimeout) {
  if (!entry.chainId.length) {
    throw new Error('Entry should contain a chain id to be revealed');
  }

  return revealInternal(factomd, entry, composeEntryReveal, 'reveal-entry', ackTimeout);
}

function revealInternal(_x10, _x11, _x12, _x13) {
  return _revealInternal.apply(this, arguments);
} //////////// Add /////////////


function _revealInternal() {
  _revealInternal = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(factomd, obj, composeReveal, revealApiCall) {
    var ackTimeout,
        reveal,
        revealed,
        _args4 = arguments;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            ackTimeout = _args4.length > 4 && _args4[4] !== undefined ? _args4[4] : 60;
            reveal = composeReveal(obj).toString('hex');
            _context4.next = 4;
            return factomd.call(revealApiCall, {
              entry: reveal
            });

          case 4:
            revealed = _context4.sent;

            if (!(ackTimeout >= 0)) {
              _context4.next = 8;
              break;
            }

            _context4.next = 8;
            return waitOnRevealAck(factomd, revealed.entryhash, revealed.chainid, ackTimeout);

          case 8:
            return _context4.abrupt("return", {
              chainId: revealed.chainid,
              entryHash: revealed.entryhash
            });

          case 9:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _revealInternal.apply(this, arguments);
}

function add(factomd, obj, ecAddress, options) {
  if (isIterable(obj)) {
    return addIterableInternal(factomd, obj, ecAddress, options);
  } else {
    return addDispatch(factomd, obj, ecAddress, options);
  }
}

function addDispatch(factomd, obj, ecAddress, options) {
  switch (obj.constructor) {
    case Entry:
      return addEntry(factomd, obj, ecAddress, options);

    case Chain:
      return addChain(factomd, obj, ecAddress, options);

    default:
      throw new Error('Argument of `add` is not an instance of Chain or Entry');
  }
}

function addChain(factomd, chain, ecAddress, options) {
  return addInternal(factomd, chain, commitChain, revealChain, ecAddress, options);
}

function addEntry(_x14, _x15, _x16, _x17) {
  return _addEntry.apply(this, arguments);
}

function _addEntry() {
  _addEntry = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5(factomd, entry, ecAddress, options) {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (entry.chainId.length) {
              _context5.next = 2;
              break;
            }

            throw new Error('Entry should contain a chain id to be added to the blockchain');

          case 2:
            return _context5.abrupt("return", addInternal(factomd, entry, commitEntry, revealEntry, ecAddress, options));

          case 3:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _addEntry.apply(this, arguments);
}

function addInternal(_x18, _x19, _x20, _x21, _x22) {
  return _addInternal.apply(this, arguments);
}

function _addInternal() {
  _addInternal = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee6(factomd, obj, commitFn, revealFn, ecAddress) {
    var options,
        commitAckTimeout,
        revealAckTimeout,
        committed,
        revealed,
        result,
        _args6 = arguments;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            options = _args6.length > 5 && _args6[5] !== undefined ? _args6[5] : {};

            if (options.skipFundValidation) {
              _context6.next = 4;
              break;
            }

            _context6.next = 4;
            return validateFunds(factomd, ecAddress, obj.ecCost());

          case 4:
            commitAckTimeout = options.commitTimeout || 60;
            revealAckTimeout = options.revealTimeout || 60;

            if (!(commitAckTimeout < 0)) {
              _context6.next = 14;
              break;
            }

            _context6.next = 9;
            return Promise.all([commitFn(factomd, obj, ecAddress, {
              ackTimeout: commitAckTimeout,
              sign: options.sign
            }), revealFn(factomd, obj, revealAckTimeout)]);

          case 9:
            result = _context6.sent;
            committed = result[0];
            revealed = result[1];
            _context6.next = 20;
            break;

          case 14:
            _context6.next = 16;
            return commitFn(factomd, obj, ecAddress, {
              ackTimeout: commitAckTimeout,
              sign: options.sign
            });

          case 16:
            committed = _context6.sent;
            _context6.next = 19;
            return revealFn(factomd, obj, revealAckTimeout);

          case 19:
            revealed = _context6.sent;

          case 20:
            return _context6.abrupt("return", Object.assign({}, committed, revealed));

          case 21:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _addInternal.apply(this, arguments);
}

function addIterableInternal(_x23, _x24, _x25) {
  return _addIterableInternal.apply(this, arguments);
}

function _addIterableInternal() {
  _addIterableInternal = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee7(factomd, iterable, ecAddress) {
    var options,
        totalCost,
        concurrency,
        _args7 = arguments;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            options = _args7.length > 3 && _args7[3] !== undefined ? _args7[3] : {};

            if (options.skipFundValidation) {
              _context7.next = 6;
              break;
            }

            // Skip individual objects fund validation
            options.skipFundValidation = true;
            totalCost = iterable.reduce(function (cost, el) {
              return cost + el.ecCost();
            }, 0);
            _context7.next = 6;
            return validateFunds(factomd, ecAddress, totalCost);

          case 6:
            // chunkSize is a legacy name kept for backward compatibility
            concurrency = options.chunkSize || options.concurrency || 200;
            return _context7.abrupt("return", Promise.map(iterable, function (entry) {
              return addDispatch(factomd, entry, ecAddress, options);
            }, {
              concurrency: concurrency
            }));

          case 8:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _addIterableInternal.apply(this, arguments);
}

function validateFunds(_x26, _x27, _x28) {
  return _validateFunds.apply(this, arguments);
}

function _validateFunds() {
  _validateFunds = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee8(factomd, ecAddress, cost) {
    var ecPublic, _ref2, balance;

    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            ecPublic = getPublicAddress(ecAddress);
            _context8.next = 3;
            return factomd.call('entry-credit-balance', {
              address: ecPublic
            });

          case 3:
            _ref2 = _context8.sent;
            balance = _ref2.balance;

            if (!(balance < cost)) {
              _context8.next = 7;
              break;
            }

            throw new Error("".concat(ecPublic, " current balance (").concat(balance, " EC) is not sufficient to pay the total cost of ").concat(cost, " EC."));

          case 7:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _validateFunds.apply(this, arguments);
}

var addEntries = addIterableInternal;
var addChains = addIterableInternal;
module.exports = {
  add: add,
  addChain: addChain,
  addChains: addChains,
  addEntry: addEntry,
  addEntries: addEntries,
  commit: commit,
  commitEntry: commitEntry,
  commitChain: commitChain,
  reveal: reveal,
  revealEntry: revealEntry,
  revealChain: revealChain
};